import { MeetingWhereInput } from '@/@generated/codegen/API';
import { useQueryParams } from '@/hooks/useQueryParams';
import { QUERY_PARAM_GLOBAL_FILTER_KEY } from '@/hooks/useTableQueryParamsUtils';
import { parseBooleanQueryParam } from '@/utils/query-params/parseBooleanQueryParam';
import { parseDateQueryParam } from '@/utils/query-params/parseDateQueryParam';
import { parseStringQueryParam } from '@/utils/query-params/parseStringQueryParam';
import { useOrderByQueryParam } from '@/utils/query-params/useOrderByQueryParam';
import { usePaginationQueryParam } from '@/utils/query-params/usePaginationQueryParam';

export const useAdminMeetingListQueryParams = (pageSize: number, prefix: string) => {
  const queryObject = useQueryParams(
    [
      QUERY_PARAM_GLOBAL_FILTER_KEY,
      'createdAt',
      'updatedAt',
      'name',
      'eventDate',
      'isArchived',
      'eventLocation',
      'purchaseOrderNbr',
      'meetingType',
      'isInTesting',
      'isDemo',

      'clientName',
      'teamName',
      'caseClusterName',
      'hostName',
    ],
    prefix
  );
  const { q } = queryObject;

  const orderByArgs = useOrderByQueryParam(prefix);
  const paginationArgs = usePaginationQueryParam(pageSize, prefix);
  const where: MeetingWhereInput = {
    AND: [
      q
        ? {
            OR: [
              { id: parseStringQueryParam(q) },
              { name: parseStringQueryParam(q) },
              {
                clients: {
                  some: {
                    name: parseStringQueryParam(q),
                  },
                },
              },
              {
                teams: {
                  some: {
                    name: parseStringQueryParam(q),
                  },
                },
              },
              {
                caseCluster: {
                  is: {
                    name: parseStringQueryParam(q),
                  },
                },
              },
              {
                host: {
                  is: {
                    email: parseStringQueryParam(q),
                  },
                },
              },
            ],
          }
        : {},
      {
        createdAt: parseDateQueryParam(queryObject.createdAt),
        updatedAt: parseDateQueryParam(queryObject.updatedAt),
        name: parseStringQueryParam(queryObject.name),
        eventDate: parseDateQueryParam(queryObject.eventDate),
        isArchived: parseBooleanQueryParam(queryObject.isArchived),
        eventLocation: parseStringQueryParam(queryObject.eventLocation),
        purchaseOrderNbr: parseStringQueryParam(queryObject.purchaseOrderNbr),
        meetingType: parseStringQueryParam(queryObject.meetingType),
        isInTesting: parseBooleanQueryParam(queryObject.isInTesting),
        isDemo: parseBooleanQueryParam(queryObject.isDemo),
      },
      queryObject.clientName
        ? {
            clients: {
              some: {
                name: parseStringQueryParam(queryObject.clientName),
              },
            },
          }
        : {},
      queryObject.teamName
        ? {
            teams: {
              some: {
                name: parseStringQueryParam(queryObject.teamName),
              },
            },
          }
        : {},
      queryObject.caseClusterName
        ? {
            caseCluster: {
              is: {
                name: parseStringQueryParam(queryObject.caseClusterName),
              },
            },
          }
        : {},
      queryObject.hostName
        ? {
            host: {
              is: {
                email: parseStringQueryParam(queryObject.hostName),
              },
            },
          }
        : {},
    ],
  };

  return {
    paginationArgs,
    orderByArgs,
    where,
  };
};
